import { getActivityCalendar } from './getActivityCalendar';
import { getDailySummary } from './getDailySummary';
import { addPlayer } from './addPlayer';
import { editPlayer } from './editPlayer';
import { getPlayers } from './getPlayers';
import { getProgram } from './getProgram';
import { getPrograms } from './getPrograms';
import { getProgramConflicts } from './getProgramConflicts';
import { searchPlayers } from './searchPlayers';
import { updatePlayerRestorativeFlag } from './updatePlayerRestorativeFlag';
import { removePlayerFromRestorative } from './removePlayerFromRestorative';
import { checkForPlayerNameDup } from './checkPlayerNameDup';

export interface IRestorative {
  getProgram: typeof getProgram;
  getPrograms: typeof getPrograms;
  getActivityCalendar: typeof getActivityCalendar;
  getDailySummary: typeof getDailySummary;
  addPlayer: typeof addPlayer;
  getPlayers: typeof getPlayers;
  editPlayer: typeof editPlayer;
  getProgramConflicts: typeof getProgramConflicts;
  searchPlayers: typeof searchPlayers;
  updatePlayerRestorativeFlag: typeof updatePlayerRestorativeFlag;
  removePlayerFromRestorative: typeof removePlayerFromRestorative;
  checkForPlayerNameDup: typeof checkForPlayerNameDup;
}

/**
 * @namespace
 */
const Restorative: IRestorative = {
  getProgram,
  getPrograms,
  getActivityCalendar,
  getDailySummary,
  addPlayer,
  getPlayers,
  editPlayer,
  getProgramConflicts,
  searchPlayers,
  updatePlayerRestorativeFlag,
  removePlayerFromRestorative,
  checkForPlayerNameDup,
};

export default Restorative;
